<template>
	<!-- Follow Up -->
	<modal
		class="follow-up-modal"
		@close="close">
		<template slot="header">
			<h3><b>{{ $t('Follow Up') }}</b></h3>
		</template>
		<template slot="body">
			<div class="form-group">
				<label class="mb-0">
					<b>{{ $t('Name') }}: </b> <span>{{ name }}</span>
				</label>
			</div>
			<div class="form-group">
				<label><b>{{ $t('Phone Number') }}</b></label>
				<input
					type="text"
					class="form-control"
					v-model="number">
			</div>
			<div class="form-group">
				<label><b>{{ $t('Text') }}</b></label>
				<textarea
					rows="5"
					class="form-control"
					v-model="messageField">
				</textarea>
			</div>
		</template>
		<template slot="footer">
			<button
				class="btn btn-light"
				@click="close">
					{{ $t('Close') }}
			</button>
			<a
				:href="url"
				target="_blank"
				class="btn btn-primary">
				{{ $t('Follow Up') }}
			</a>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { generateWaUrl } from '@/lib/helper';

export default {
	name: 'FollowUpModal',
	components: {
		Modal,
	},
	data() {
		return {
			messageField: '',
		};
	},
	props: {
		name: {
			type: String,
			required: true,
		},
		number: {
			type: String,
			required: true,
		},
		message: {
			type: String,
			required: true,
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
	computed: {
		url() {
			const url = generateWaUrl(this.number, this.messageField);
			return url;
		},
	},
	watch: {
		message(newValue) {
			this.messageField = newValue;
		},
	},
};
</script>
